








































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import {
  BButton, BModal, BForm, BFormInput, BFormGroup, BSpinner, BPagination
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { Region } from '@/api/models/options/entreprises/region';
import { PaginatedList } from '@/api/models/common/paginatedList';
import { successAlert, errorAlert } from '@/libs/sweetAlerts/alerts';
import { RegionCreateModel } from '@/api/models/options/entreprises/region'
import { required, min, max } from '@validations'
import DeleteIcon from '@/components/icons/DeleteIcon.vue'
import EditIcon from '@/components/icons/EditIcon.vue'

@Component({
  components: {
    BForm,
    BModal,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BButton,
    BFormGroup,
    BPagination,
    BSpinner,
    DeleteIcon,
    EditIcon
  }
})
export default class RegionEntreprise extends Vue {
  @Prop() sharedEntreprise!: boolean;
  currentPageRegions: PaginatedList<Region> | null = null
  selectedRegion: Region | null = null;

  currentPage: number = 1;
  perPage: number = 10;
  listLoading = false

  newRegion: RegionCreateModel = {}

  required = required;
  min = min;
  max = max;
  
  async created() {
    await this.loadListRegion();
  }

  async loadListRegion() {
    this.listLoading = true
    await this.$http.ressifnet.regions.paginatedList(this.$route.params.id, this.currentPage, this.perPage,'')
      .then(
        (response: PaginatedList<Region>) => {
          this.listLoading = false
          this.currentPageRegions = response
        }, (error: any) => {
          this.listLoading = false
          errorAlert.fire({
            title: 'Erreur lors du chargement des régions'
          })
        }
      )
      this.newRegion = {};
  }

  @Watch('currentPage')
    async onPageChanged() {
      await this.loadListRegion();
  }

  async deleteRegion(id : string) {
    this.$bvModal
        .msgBoxConfirm('Etes-vous sûr de vouloir supprimer la région ?', {
          title: 'Confirmation de suppression',
          size: 'sm',
          okVariant: 'primary',
          okTitle: 'Oui',
          cancelTitle: 'Non',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(async value => {
          if(value === true){
            await this.confirmDelete(id)
          } 
          else {
            return
          }
        })
  }

  async confirmDelete(id : string) {
    await this.$http.ressifnet.regions.delete(this.$route.params.id, id)
      .then(async(response: string) => {
        successAlert.fire({
          title: "Suppression d\'une région",
          text: "Suppression effectuée avec succès"
        })
        await this.loadListRegion()
      }, (error: any) => {
        if (error.response?.data?.detail && error.response.data.detail.length > 0){
          errorAlert.fire({
            text: error.response.data.detail
          })
        } else {
          errorAlert.fire({
            text: error.message
          })
        }    
  })
}

  async createRegion(event: any) {
    event.preventDefault();
    (this.$refs.createFormValidation as InstanceType<typeof ValidationObserver>)
      .validate()
      .then(async (isSuccess) => {
        if (isSuccess) {
          await this.$http.ressifnet.regions.post(this.$route.params.id, this.newRegion)
            .then(async (response : string) => {
              this.$bvModal.hide('modal-add-region')
              successAlert.fire({
                title: 'Création d\'une région',
                text: 'Ajout effectué avec succès'
              })
              await this.loadListRegion()
            }, (error: any) => {
              if (error.response.data.errors) {
                errorAlert.fire({
                  text: error.response.data.errors[Object.keys(error.response.data.errors)[0]]
                })
              }
              else {
                this.$bvModal.hide('modal-add-region')
                errorAlert.fire({
                  title: 'Oops',
                  text: error.message
                })
              }
            })
        }
      })
  }

  async updateRegion(id : string) {
    this.selectedRegion = JSON.parse(JSON.stringify(this.currentPageRegions!.items.find(x => x.id == id)));
    this.$bvModal.show('modal-put-region');
  }

  async confirmUpdate(event: any) {
    event.preventDefault();
    (this.$refs.createFormValidation as InstanceType<typeof ValidationObserver>)
      .validate()
      .then(async (isSuccess) => {
        if (isSuccess) {
          if(!this.selectedRegion)
            return;

          await this.$http.ressifnet.regions.put(this.$route.params.id, this.selectedRegion.id, this.selectedRegion)
            .then(async(response: any) => {
              this.$bvModal.hide('modal-put-region');
              successAlert.fire({
                title: 'Modification d\'une region',
                text: 'Modification effectuée avec succès',
              })

              await this.loadListRegion()
            }, (error: any) => {
              if (error.response.data.errors) {
                errorAlert.fire({
                  text: error.response.data.errors[Object.keys(error.response.data.errors)[0]]
                })
              }
              else {
                this.$bvModal.hide('modal-put-region');
                errorAlert.fire({
                  text: error.message,
                })
              }
            });
        }
      })
  }

}
    
